import type { IndexModel } from "@/api/models"

export interface FlowLibraryOption {
  id: string
  name: string
  description: string
}

/** Libraries selectable for library_search in a flow — same "flow" blocked_modules
 * check the Agent node's picker uses (agent-node.tsx), factored out so the Tool
 * node's picker (#2540) doesn't duplicate it a third time (use-workflow-test-run.ts
 * already has its own copy for the "which libraries can this flow use" default). */
export function getFlowLibraryOptions(indexes: IndexModel[]): FlowLibraryOption[] {
  return indexes
    .filter((index) => !index.blocked_modules || !index.blocked_modules.includes("flow"))
    .map((index) => ({ id: index.id, name: index.display_name, description: index.description }))
}

export const M365_TOOL_ACTIONS = [
  { value: "get_emails", label: "Get Emails", kind: "read" },
  { value: "get_calendar_events", label: "Get Calendar Events", kind: "read" },
  { value: "search_teams", label: "Search Teams", kind: "read" },
  { value: "get_files", label: "Get Files", kind: "read" },
  { value: "get_meeting_insights", label: "Get Meeting Insights", kind: "read" },
  { value: "send_email", label: "Send Email", kind: "write" },
] as const

export type M365ToolAction = (typeof M365_TOOL_ACTIONS)[number]["value"]

export function getM365ToolActionAllowList(action: string): string[] | undefined {
  if (M365_TOOL_ACTIONS.some((option) => option.value === action)) {
    return [action]
  }

  return undefined
}

export function parseM365Recipients(value: string): string[] {
  return value
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean)
}

export const WEB_SEARCH_MODES = [
  { value: "all", label: "All web sources" },
  { value: "trusted_only", label: "Only trusted sources" },
] as const

export type ToolParameters = Record<string, string | string[]>
export type ToolConfigValue = string | string[] | ToolParameters
export type ToolConfig = Record<string, ToolConfigValue>

export function toolConfigString(value: unknown): string {
  return typeof value === "string" ? value : ""
}
